/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { O as Orientation, V as Variants } from './constants-c94b83bd.js';

const DHL_HEADLINE_COLOR = {
    BLACK: "black",
    WHITE: "white",
    RED: "red",
    DEFAULT: "default",
};
const DHL_HEADLINE_DESIGN_LEVEL = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
};
const DHL_HEADLINE_STRETCH = {
    NORMAL: "normal",
    CONDENSED: "condensed",
};
const DHL_HEADLINE_TEXT_TRANSFORM = {
    NONE: "none",
    UPPERCASE: "uppercase",
    CAPITALIZE: "capitalize",
    LOWERCASE: "lowercase",
};
const DHL_HEADLINE_TEXT_ALIGN = {
    LEFT: Orientation.left,
    CENTER: Orientation.center,
    RIGHT: Orientation.right,
};
const DHL_HEADLINE_WEIGHT = {
    BLACK: Variants.black,
    LIGHT: Variants.light,
};
const DHL_HEADLINE_TAG = {
    H1: "h1",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    H5: "h5",
    H6: "h6",
    P: "p",
};
const DHL_HEADLINE = {
    COLOR: DHL_HEADLINE_COLOR,
    DESIGN_LEVEL: DHL_HEADLINE_DESIGN_LEVEL,
    STRETCH: DHL_HEADLINE_STRETCH,
    TEXT_TRANSFORM: DHL_HEADLINE_TEXT_TRANSFORM,
    TEXT_ALIGN: DHL_HEADLINE_TEXT_ALIGN,
    WEIGHT: DHL_HEADLINE_WEIGHT,
    TAG: DHL_HEADLINE_TAG,
};

export { DHL_HEADLINE as D };

//# sourceMappingURL=constants-366d7065.js.map